<template>
  <div class="customer">
    <van-sticky>
      <div class="header">
        <div class="headerIcon">
          <!-- <van-icon name="arrow-left" color="#fff" @click="returnIndex" /> -->
          <van-search placeholder="查找" style="margin:0 10px;" />
        </div>
      </div>
      <div>
        诊室页面待开发。。。
      </div>
    </van-sticky>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  }
}

</script>
<style scoped>
@import "../../assets/css/customer.css";
</style>



// WEBPACK FOOTER //
// src/components/customerReception/reception.vue